import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Divider } from '@design-system/divider';
import { FONT_BRIGHTNESS } from '@design-system/theme';
import { CursorPointerWrapper, LinkWrapper, StyledLink } from './LinkWrapper';
const DEFAULT_GAP = { _: 5, m: 6 };
const DEFAULT_BORDER_GAP = 5;
const VariantDivided = ({ children, gap = 2, isLast, onClick, path, }) => (_jsxs(Box, { as: "li", "data-testid": "content-list-item", flex: 1, flexDirection: "column", children: [_jsx(LinkWrapper, { onClick: onClick, path: path, children: _jsx(DividedContainer, { "data-testid": "content-list-item-with-divider", children: children }) }), !isLast && _jsx(Divider, { "aria-hidden": true, my: gap })] }));
const VariantDefault = ({ children, gap = DEFAULT_GAP, isLast, onClick, path, }) => (_jsx(Box, { as: "li", "data-testid": "content-list-item", mb: isLast ? 0 : gap, children: _jsx(LinkWrapper, { onClick: onClick, path: path, children: _jsx(DefaultContainer, { "data-testid": "content-list-item-default", children: children }) }) }));
const VariantBordered = ({ children, gap = DEFAULT_BORDER_GAP, isLast, onClick, path, }) => (_jsx(Box, { as: "li", "data-testid": "content-list-item", mb: isLast ? 0 : gap, children: _jsx(LinkWrapper, { onClick: onClick, path: path, children: _jsx(BorderedContainer, { "data-testid": "content-list-item-with-border", children: children }) }) }));
export const ItemWrapper = (_a) => {
    var { variant = 'default' } = _a, props = __rest(_a, ["variant"]);
    if (variant === 'divider') {
        return _jsx(VariantDivided, Object.assign({}, props));
    }
    if (variant === 'bordered') {
        return _jsx(VariantBordered, Object.assign({}, props));
    }
    return _jsx(VariantDefault, Object.assign({}, props));
};
export default ItemWrapper;
const DefaultContainer = styled(Box).attrs({
    width: '100%',
    flexDirection: 'row',
}) `
  ${StyledLink}:focus &,
  ${StyledLink}:hover &,
  ${CursorPointerWrapper}:focus &,
  ${CursorPointerWrapper}:hover & {
    text-decoration: none;
  }
  ${StyledLink}:has(&) {
    text-decoration: none;
  }
`;
const DividedContainer = styled(Box).attrs({
    width: '100%',
    flexDirection: 'row',
    p: 4,
}) `
  position: relative;

  ${StyledLink}:focus &,
  ${StyledLink}:hover &,
  ${CursorPointerWrapper}:focus &,
  ${CursorPointerWrapper}:hover & {
    text-decoration: none;
  }

  ${StyledLink}:has(&),
  ${CursorPointerWrapper}:has(&) {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      display: none;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: ${({ theme }) => theme.colors.smoke};
    }
    &:focus,
    &:hover {
      &:before {
        display: block;
      }
    }
  }
  ${StyledLink}:has(&) {
    text-decoration: none;
  }
`;
const BorderedContainer = styled(Box).attrs({
    flexDirection: 'row',
    minHeight: { m: '145px' },
    p: 4,
}) `
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  align-items: center;
  overflow: hidden;
  position: relative;
  width: 100%;

  border: 1px solid
    ${({ theme }) => {
    if (theme.themeVariables.fontBrightness === FONT_BRIGHTNESS.LIGHT) {
        return theme.colors.snow;
    }
    return theme.colors.horizon;
}};

  ${StyledLink}:hover &,
  ${StyledLink}:focus &,
  ${CursorPointerWrapper}:hover &,
  ${CursorPointerWrapper}:focus & {
    border-color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
  }
  ${StyledLink}:has(&) {
    text-decoration: none;
  }
`;
//# sourceMappingURL=ItemWrapper.js.map